import { Component, OnInit, Directive } from "@angular/core";
import { AuthenticationService } from "../../authentication/authentication.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-page-no-header",
  templateUrl: "./page-no-header.component.html",
  styleUrls: ["./page-no-header.component.scss"],
})
export class PageNoHeaderComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {}

  logOut() {
    this.router.navigate(["/home"]);
    this.authenticationService.logout();
  }
}
